const ArcaneList=[
    {
        Id:'a01',
        Name:'VITA',
        Erinni:'CORPO',
        Description:'Vita, è l’Arcano di tutto ciò che è biologico. Questo arcano crea e manipola la vita stessa degli esseri viventi.',
    },
    {
        Id:'a02',
        Name:'MORTE',
        Erinni:'CORPO',
        Description:"Morte, è l’Arcano della fine, del mondo dei morti e dell’oscurità. Di tutto ciò che un tempo è stato vivo e ora non lo è più.",  
    },
    {
        Id:'a03',
        Name:'FATO',
        Erinni:'SENSI',
        Description:"Fato, è l’Arcano del destino, benedizioni, maledizioni, giuramenti e probabilità. ",  
    },
    {
        Id:'a04',
        Name:'PRIMUS',
        Erinni:'SENSI',
        Description:"Primus, è l’Arcano della magia stessa, della trama magica e del suo intreccio.",  
    },
    {
        Id:'a05',
        Name:'MENTE',
        Erinni:'MENTE',
        Description:"Mente, è l’Arcano della coscienza e del pensiero, può agire su qualunque cosa sia in grado di formulare un pensiero o un’emozione.",  
    },
    {
        Id:'a06',
        Name:'SPAZIO',
        Erinni:'MENTE',
        Description:"Spazio, è l’Arcano di distanze, spostamenti e relazioni.",  
    },
    {
        Id:'a07',
        Name:'TEMPO',
        Erinni:'VUOTO',
        Description:"Tempo, è l’Arcano del tempo stesso, permette la chiaroveggenza, preveggenza, piccole forme di controllo del passaggio del tempo",  
    },
    {
        Id:'a08',
        Name:'SPIRITO',
        Erinni:'VUOTO',
        Description:"Spirito, è l’Arcano dell’effimero, delle entità spirituali e delle anime di coloro che hanno abbandonato la vita.",  
    },
    {
        Id:'a09',
        Name:'MATERIA',
        Erinni:'FORMA',
        Description:"Materia, è l'arcano che permette di conoscere e manipolare tutto ciò che è materiale, purché non sia (o lo sia stato) vivo.",  
    },
    {
        Id:'a10',
        Name:'FORZE',
        Erinni:'FORMA',
        Description:"Forze, è l’Arcano di fuoco, elettricità, luce, suono e ogni tipo di energia.",  
    },
    ]

    export {ArcaneList}